(function () {
	const slideUp = (el, duration = 300) => {
		if (el.slideTimeout) clearTimeout(el.slideTimeout);

		el.style.overflow = 'hidden';
		el.style.height = el.offsetHeight + 'px';
		el.style.transition = `height ${duration}ms ease`;

		requestAnimationFrame(() => { el.style.height = '0'; });

		el.slideTimeout = setTimeout(() => {
			el.style.display = 'none';
			el.style.height = el.style.overflow = el.style.transition = '';
		}, duration);
	};

	const slideDown = (el, duration = 300) => {
		if (el.slideTimeout) clearTimeout(el.slideTimeout);

		el.style.display = 'block';
		const height = el.scrollHeight;
		el.style.overflow = 'hidden';
		el.style.height = '0';
		el.style.transition = `height ${duration}ms ease`;

		requestAnimationFrame(() => { el.style.height = height + 'px'; });

		el.slideTimeout = setTimeout(() => {
			el.style.height = el.style.overflow = el.style.transition = '';
		}, duration);
	};

	const getSiblings = (el, selector) =>
		Array.from(el.parentElement?.children || [])
			.filter(child => child !== el && child.matches(selector));

	const initProductAccordion = () => {
		const aboutToggleItems = document.querySelectorAll(".about__accordion-toggle");

		aboutToggleItems.forEach(function(currentToggle) {
			const siblingDescriptions = getSiblings(currentToggle, ".about__accordion-description");

			currentToggle.addEventListener('click', function() {
				if (!currentToggle.classList.contains("active")) {
					aboutToggleItems.forEach(function(toggle) {
						if (toggle === currentToggle) return;
						toggle.classList.remove("active");
						getSiblings(toggle, ".about__accordion-description").forEach(desc => slideUp(desc));
					});

					currentToggle.classList.add("active");
					siblingDescriptions.forEach(desc => slideDown(desc));
				} else {
					currentToggle.classList.remove("active");
					siblingDescriptions.forEach(desc => slideUp(desc));
				}
			});
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(".product-media-modal__content");
		const images = imagesWrapper?.querySelectorAll(".js-image-zoom") || [];

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = theme.moneyFormat;

		return formatString.replace(placeholderRegex, value);
	}

	const setTotalFreeShipping = () => {
		if (document.querySelector('.js-free-shipping')) {
			const freeShippingTotal = document.querySelector('.free-shipping-total');
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend);
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(Math.round(minSpend * (Shopify.currency.rate || 1)))}`;
				}
			}
		}
	}

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		setTotalFreeShipping();
	});

	initProductAccordion();
	initZoomImage();
	setTotalFreeShipping();
})();